<template>
  <div class="user-cabinet" v-if="isMatchmaking || isGroups">
    <div class="user-cabinet__wrap">
      <nav>
        <ul class="user-cabinet__submenu">
          <template v-if="isMatchmaking">
            <li>
              <a href="#" :class="{ active: isBuyer }" @click.prevent="setBuyer(true)">
                <i class="icon-buy"></i>
                <span class="matchmaking-mode-label">
                  Buy
                  <MarketplaceUnreadBadge :count="buyerUnread" />
                </span>
              </a>
            </li>

            <li>
              <a href="#" :class="{ active: !isBuyer }" @click.prevent="setBuyer(false)">
                <i class="icon-sell"></i>
                <span class="matchmaking-mode-label">
                  Sell
                  <MarketplaceUnreadBadge :count="sellerUnread" />
                </span>
              </a>
            </li>
          </template>

          <template v-if="isGroups">
            <li>
              <router-link :to="{ name: 'profileGroups' }" :class="{ active: isGroupsMain }">
                <i class="icon-group3"></i>
                <span>My Strategy Groups</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'profileGroupsRequest' }" :class="{ active: !isGroupsMain }">
                <i class="icon-request"></i>
                <span>ADD NEW GROUP</span>
              </router-link>
            </li>
          </template>
        </ul>
      </nav>

      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import MarketplaceUnreadBadge from '@/components/matchmaking/MarketplaceUnreadBadge.vue';

export default {
  name: 'UserCabinetSubmenu',
  components: {
    MarketplaceUnreadBadge,
  },
  computed: {
    buyerUnread() {
      return Number(this.$store.getters.getUnreadBuyerMarketplace) || 0;
    },
    sellerUnread() {
      return Number(this.$store.getters.getUnreadSellerMarketplace) || 0;
    },
    marketplaceUnreadTotal() {
      return this.buyerUnread + this.sellerUnread;
    },
    isBuyer() {
      const routePath = String(this.$route.path || '');
      if (routePath.includes('/profile/matchmaking/seller')) return false;
      if (routePath.includes('/profile/matchmaking/buyer')) return true;
      return this.$route.params.type === 'buyer';
    },
    isLoading() {
      return this.$store.getters.isLoading;
    },
    isMatchmaking() {
      return this.$route.path.includes('matchmaking');
    },
    isGroups() {
      return this.$route.path.startsWith('/profile/groups') || this.$route.name === 'profileGroupsRequest';
    },
    isGroupsMain() {
      return this.$route.name === 'profileGroups';
    },
  },
  methods: {
    setBuyer(predicate) {
      if (this.isLoading || this.isBuyer === predicate) return;

      if (predicate) {
        this.$store.commit('SET_IS_BUYER', true);
        this.$eventBus.$emit('setMatchmaking', this.marketplaceUnreadTotal, 'matchmaking');
        this.$router.push('/profile/matchmaking/buyer');
      } else {
        this.$store.commit('SET_IS_BUYER', false);
        this.$eventBus.$emit('setMatchmaking', this.marketplaceUnreadTotal, 'matchmaking');
        this.$router.push('/profile/matchmaking/seller');
      }
    },
  },
};
</script>

<style scoped>
.matchmaking-mode-label {
  display: inline-flex;
  align-items: center;
}
</style>
